import React from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../../../../generic/ui/DatePicker';
import CustomerSelector from '../../../../../../generic/ui/Selectors/CustomerSelector';
import PalletTypeSelector from '../../../../../../generic/ui/Selectors/PalletTypeSelector';
import KbdChipButton from '../../../../../../generic/ui/KbdChipButton/KbdChipButton';
import PrintIcon from '../../../../../../generic/icons/IconLib/PrintIcon';
import TruckIcon from '../../../../../../generic/icons/IconLib/TruckIcon';
import WrenchIcon from '../../../../../../generic/icons/IconLib/WrenchIcon';
import PalletIcon from '../../../../../../generic/icons/IconLib/PalletIcon';
import { IClientsItem } from '../../../../../../modules/API/Defaults/models/customers';
import { IPalletTypeItem } from '../../../../../../modules/API/Defaults/models/pallets';

interface Props {
    chekLikut: boolean;
    clientID: number | null;
    setDate: (value: string) => void;
    customers: IClientsItem[] | null;
    selectedCustomer: IClientsItem | null;
    onSelectClient: (customer: IClientsItem | null) => void;
    palletTypes: IPalletTypeItem[];
    selectedPalletType: IPalletTypeItem | null;
    onSelectPalletType: (item: IPalletTypeItem | null) => void;
    showPrintTeuda: boolean;
    onPrintTeuda: () => void;
    onOpenDriver: () => void;
    onOpenPrinterSettings: () => void;
    palletQtySum: number;
    onOpenPalletsModal: () => void;
}

const PalletSelectBar: React.FC<Props> = ({
    chekLikut,
    clientID,
    setDate,
    customers,
    selectedCustomer,
    onSelectClient,
    palletTypes,
    selectedPalletType,
    onSelectPalletType,
    showPrintTeuda,
    onPrintTeuda,
    onOpenDriver,
    onOpenPrinterSettings,
    palletQtySum,
    onOpenPalletsModal,
}) => {
    return (
        <BarColumn>
            {chekLikut && (
                <BarRow>
                    <SelectorShell>
                        <CustomerSelector
                            customers={customers ?? []}
                            value={selectedCustomer}
                            onSelect={onSelectClient}
                            placeholder='בחר לקוח'
                        />
                    </SelectorShell>
                    <DatePicker setDate={setDate} />
                </BarRow>
            )}
            {(!chekLikut || !!clientID) && (
                <BarRow>
                    {!chekLikut && (
                        <KbdChipButton
                            count={palletQtySum}
                            onClick={onOpenPalletsModal}
                            aria-label='משטחים בהזמנה'
                            title='משטחים בהזמנה'
                        >
                            <PalletIcon size={16} color='currentColor' />
                        </KbdChipButton>
                    )}
                    <KbdChipButton
                        onClick={onOpenPrinterSettings}
                        aria-label='הגדרות מדפסת'
                        title='הגדרות מדפסת'
                    >
                        <WrenchIcon size={16} color='currentColor' />
                    </KbdChipButton>
                    <SelectorShell>
                        <PalletTypeSelector
                            palletTypes={palletTypes}
                            value={selectedPalletType}
                            onSelect={onSelectPalletType}
                        />
                    </SelectorShell>
                    {showPrintTeuda && (
                        <KbdChipButton
                            variant='accent'
                            onClick={onPrintTeuda}
                            aria-label='הדפס תעודה'
                            title='הדפס תעודה'
                        >
                            <PrintIcon size={16} color='currentColor' />
                        </KbdChipButton>
                    )}
                    {chekLikut && (
                        <KbdChipButton
                            onClick={onOpenDriver}
                            aria-label='בחר נהג'
                            title='בחר נהג'
                        >
                            <TruckIcon size={16} color='currentColor' />
                        </KbdChipButton>
                    )}
                    
                    
                </BarRow>
            )}
        </BarColumn>
    );
};

export default PalletSelectBar;

const BarColumn = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex-shrink: 0;
`;

const BarRow = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const SelectorShell = styled.div`
    flex: 1;
    min-width: 0;
`;
